export default __webpack_public_path__ + "static/media/overviewBg.7876e71e.png";